import { render, staticRenderFns } from "./Dropfiles.vue?vue&type=template&id=190a6735"
import script from "./Dropfiles.vue?vue&type=script&lang=js"
export * from "./Dropfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports